import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import Home from "./components/admin/Home";
import Auctions from "./components/admin/Auctions";
import AuctionHistory from "./components/admin/AuctionHistory";
import TradingHistory from "./components/admin/TradingHistory";
import Traders from "./components/admin/Traders";
import TraderDetail from "./components/admin/TraderDetail";
import Auctioneers from "./components/admin/Auctioneers";
import Companies from "./components/admin/Companies";
import LotGridView from "./components/admin/LotGridView";
import LotUpdateView from "./components/admin/LotUpdateView";
import { Layout } from './components/Layout';
import { CommonLayout } from "./components/CommonLayout";
import  TraderLayout  from "./components/TraderLayout";
import LotDetails from "./components/admin/LotDetails";
import AuctioneerDashboard from "./components/auctioneer/Auctioneer";
import AuctioneerLots from "./components/auctioneer/AuctioneerLots";
import AuctioneerLotDetails from "./components/auctioneer/AuctioneerLotDetails";
import TraderDashboard from "./components/trader/Trader";
import LiveAuction from "./components/trader/LiveAuction";
import LotOverview from "./components/auctioneer/LotOverview";
import StreamerLayout from "./components/StreamerLayout";
import StreamerDashboard from "./components/streamer/Streamer";
import LiveStream from "./components/streamer/LiveStream";
import CompletedLotsReport from "./components/trader/CompletedLotsReport";
//import LoginDetails from "./components/admin/LoginDetails";
import LotDetailReport from "./components/admin/LotDetailReport";
import BiddingHistoryReport from "./components/admin/BiddingHistoryReport";
import BidderDetailReport from "./components/admin/BidderDetailReport";
import CurrentLoginDetailReport from "./components/admin/CurrentLoginDetailReport";
import LoginHistoryReport from "./components/admin/LoginHistoryReport";
import Participants from "./components/auctioneer/Participants";
import PreviousAuctionsReport from "./components/auctioneer/PreviousAuctionsReport";
import AuctioneerLotDetailReport from "./components/auctioneer/AuctioneerLotDetailReport";
import AuctioneerBidderDetailReport from "./components/auctioneer/AuctioneerBidderDetailReport";
import AuctioneerBiddingHistoryReport from "./components/auctioneer/AuctioneerBiddingHistoryReport";
import AuctionBiddersReport from "./components/auctioneer/AuctionBiddersReport";
import AuctioneerTraderwiseReport from "./components/auctioneer/AuctioneerTraderwiseReport";
import PoolingCenters from "./components/admin/PoolingCenters";
import Pooling from "./components/poolingCenters/Pooling";
import PooledLot from "./components/poolingCenters/PooledLot";
import PoolingDetail from "./components/auctioneer/PoolingDetail";
import PoolingDetailView from "./components/admin/PoolingDetailView";
import PooledLotView from "./components/admin/PooledLotView";
import WeeklyAuctionReport from "./components/admin/WeeklyAuctionReport";
import MonthlyAuctionReport from "./components/admin/MonthlyAuctionReport";
import FullAuctionReport from "./components/admin/FullAuctionReport";
import UserFeeReport from "./components/admin/UserFeeReport";
import CSRAmountReport from "./components/admin/CSRAmountReport";
import OTPSettings from './components/auctioneer/OTPSettings'
import PooledLotAuditTrail from './components/admin/PooledLotAuditTrail'
import PreviousPoolingReport from './components/auctioneer/PreviousPoolingReport'
import PaymentDetails from "./components/auctioneer/PaymentDetails";

const AppRoutes = () => {

    const adminRoutes = [
        {
            layout: Layout,
            path: '/home',
            element: <Home />
        },
        {
            layout: Layout,
            path: '/auctions',
            element: <Auctions />
        },
        {
            layout: Layout,
            path: '/lotDetails/:id',
            element: <LotDetails />
        },
        {
            layout: Layout,
            path: '/auctionHistory',
            element: <AuctionHistory />
        }, {
            layout: Layout,
            path: '/tradingHistory',
            element: <TradingHistory />
        }, {
            layout: Layout,
            path: '/traders',
            element: <Traders />
        }, {
            layout: Layout,
            path: '/lotGridView/:id',
            element: <LotGridView />
        }, {
            layout: Layout,
            path: '/traderDetail/:id',
            element: <TraderDetail />
        }, {
            layout: Layout,
            path: '/companies',
            element: <Companies />
        }, {
            layout: Layout,
            path: '/auctioneers',
            element: <Auctioneers />
        }, {
            layout: Layout,
            path: '/poolingCenters',
            element: <PoolingCenters />
        },
        {
            layout: Layout,
            path: '/lotDetailReport/:id',
            element: <LotDetailReport />
        },
        {
            layout: Layout,
            path: '/biddingHistoryReport/:id',
            element: <BiddingHistoryReport />
        }, {
            layout: Layout,
            path: '/bidderDetailReport/:id',
            element: <BidderDetailReport />
        },
        {
            layout: Layout,
            path: '/currentLoginDetail',
            element: <CurrentLoginDetailReport />
        }, {
            layout: Layout,
            path: '/loginHistoryReport',
            element: <LoginHistoryReport />
        },
        {
            layout: Layout,
            path: '/weeklyAuctionReport',
            element: <WeeklyAuctionReport />
        },
        {
            layout: Layout,
            path: '/monthlyAuctionReport',
            element: <MonthlyAuctionReport />
        },
        {
            layout: Layout,
            path: '/fullAuctionReport',
            element: <FullAuctionReport />
        },
        {
            layout: Layout,
            path: '/userFeeReport',
            element: <UserFeeReport />
        }, {
            layout: Layout,
            path: '/csrReport',
            element: <CSRAmountReport />
        },
        {
            layout: Layout,
            path: '/poolingDetailView/:id',
            element: <PoolingDetailView />
        },
        {
            layout: Layout,
            path: '/pooledLotView/:id',
            element: <PooledLotView />
        },
        {
            layout: Layout,
            path: '/pooledLotAuditTrail/:id',
            element: <PooledLotAuditTrail />
        },
        {
            layout: Layout,
            path: '/LotUpdateView/:id',
            element: <LotUpdateView />
        },
    ];

    const auctioneerRoutes = [
        {
            layout: CommonLayout,
            path: '/auctioneer',
            element: <AuctioneerDashboard />
        },
        {
            layout: CommonLayout,
            path: '/auctioneerLots/:id',
            element: <AuctioneerLots />
        },
        {
            layout: CommonLayout,
            path: '/auctioneerLotDetails/:id',
            element: <AuctioneerLotDetails />
        },
        {
            layout: CommonLayout,
            path: '/lotOverview/:id',
            element: <LotOverview />
        },
        {
            layout: CommonLayout,
            path: '/participants',
            element: <Participants />
        }, {
            layout: CommonLayout,
            path: '/previousAuctionsReport',
            element: <PreviousAuctionsReport />
        }, {
            layout: CommonLayout,
            path: '/auctioneerLotDetailReport/:id',
            element: <AuctioneerLotDetailReport />
        }, {
            layout: CommonLayout,
            path: '/auctioneerBidderDetailReport/:id',
            element: <AuctioneerBidderDetailReport />
        },
        {
            layout: CommonLayout,
            path: '/auctioneerBiddingHistoryReport/:id',
            element: <AuctioneerBiddingHistoryReport />
        },
        {
            layout: CommonLayout,
            path: '/auctionBiddersReport/:id',
            element: <AuctionBiddersReport />
        }, {
            layout: CommonLayout,
            path: '/auctioneerTraderwiseReport/:id',
            element: <AuctioneerTraderwiseReport />
        }, {
            layout: CommonLayout,
            path: '/poolingDetail/:id',
            element: <PoolingDetail />
        },
        {
            layout: CommonLayout,
            path: '/pooledLotDetail/:id',
            element: <PooledLot />
        },
        {
            layout: CommonLayout,
            path: '/otpSettings',
            element: <OTPSettings />
        },
        {
            layout: CommonLayout,
            path: '/previousPoolingReport/:id',
            element: <PreviousPoolingReport />
        },
        {
            layout: CommonLayout,
            path: '/paymentDetails/:id',
            element: <PaymentDetails />
        },
    ];

    const traderRoutes = [
        {
            layout: TraderLayout,
            path: '/trader',
            element: <TraderDashboard />
        },
        {
            layout: TraderLayout,
            path: '/liveAuction',
            element: <LiveAuction />
        },
        {
            layout: TraderLayout,
            path: '/completedLotsReport',
            element: <CompletedLotsReport />
        }
    ];

    const streamerRoutes = [
        {
            layout: CommonLayout,
            path: '/streamer',
            element: <StreamerDashboard />
        },
        {
            layout: CommonLayout,
            path: '/streamerCompletedLotsReport',
            element: <CompletedLotsReport />
        },
        {
            layout: StreamerLayout,
            path: '/liveStream',
            element: <LiveStream />
        },
    ];

    const poolerRoutes = [
        {
            layout: CommonLayout,
            path: '/pooling',
            element: <Pooling />
        },
        {
            layout: CommonLayout,
            path: '/pooledLot/:id',
            element: <PooledLot />
        }
    ];

    return {
        adminRoutes,
        auctioneerRoutes,
        traderRoutes,
        streamerRoutes,
        poolerRoutes
    };
}

export default AppRoutes;
